export const GET_COMPANY_META_DATA_REQUEST = "GET_COMPANY_META_DATA_REQUEST";
export const GET_COMPANY_META_DATA_SUCCESS = "GET_COMPANY_META_DATA_SUCCESS";
export const GET_COMPANY_META_DATA_FAILURE = "GET_COMPANY_META_DATA_FAILURE";
export const GET_COMPANY_META_DATA_RESET = "GET_COMPANY_META_DATA_RESET";
export const getCompanyMetaDataRequest = (payload) => ({
    type: GET_COMPANY_META_DATA_REQUEST,
    payload,
});
export const getCompanyMetaDataSuccess = (payload) => ({
    type: GET_COMPANY_META_DATA_SUCCESS,
    payload,
});
export const getCompanyMetaDataFailure = (payload) => ({
    type: GET_COMPANY_META_DATA_FAILURE,
    payload,
});
export const getCompanyMetaDataReset = () => ({
    type: GET_COMPANY_META_DATA_RESET,
});
